import { Box, CircularProgress, createTheme, Dialog, DialogActions, DialogContent, Grid, MuiThemeProvider, Table, TableBody, TableCell, TableRow, TextField, Typography } from '@material-ui/core';
import MUIDataTable from 'mui-datatables';
import React, { useCallback, useImperativeHandle, useRef, useState } from 'react';
import { useFieldArray } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import ButtonUI from '../../../components/ui/ButtonUI';
import getDefaultGridOptions from '../../../utils/componentUtils';
import utilsDate from '../../../utils/Date';
import { DialogTitle, useStyles } from '../Style';
type props = any;

const LogDetailDialog = React.forwardRef((_props: {}, ref) => {
    const { t } = useTranslation("Mvm");
    const { t: _t } = useTranslation("General");
    const [open, setOpen] = useState(false);
    const [log, setLog] = useState<any>(null);

    useImperativeHandle(ref, () => ({
        open: (logData: any) => {
            setLog(logData);
            setOpen(true);
        }
    }));

    const handleClose = useCallback(() => {
        setOpen(false);
    }, []);

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            maxWidth="md"
            fullWidth
            aria-labelledby="log-detail-dialog-title"
        >
            <DialogTitle
                id="log-detail-dialog-title"
                onClose={handleClose}>
                {t("logDetail")}
            </DialogTitle>
            <DialogContent dividers>
                {log && (
                    <>
                        <Table size="small">
                            <TableBody>
                                <TableRow>
                                    <TableCell><strong>{t("logDate")}</strong></TableCell>
                                    <TableCell>{utilsDate.DateTimeSecond(log.logDate)}</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell><strong>{t("logType")}</strong></TableCell>
                                    <TableCell>{log.logTypeDescription}</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell><strong>{t("logUser")}</strong></TableCell>
                                    <TableCell>{log.createdBy}</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell><strong>{t("logUserName")}</strong></TableCell>
                                    <TableCell>{log.createdByUserName}</TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                        <TextField
                            label={t("logMessage")}
                            value={log.message || ''}
                            multiline
                            minRows={6}
                            maxRows={20}
                            fullWidth
                            variant="outlined"
                            InputProps={{ readOnly: true }}
                            style={{ marginTop: 16 }}
                        />
                    </>
                )}
            </DialogContent>
            <DialogActions>
                <ButtonUI color="secondary" onClick={handleClose}>
                    {_t("close")}
                </ButtonUI>
            </DialogActions>
        </Dialog>
    );
});

const MvmLogList: React.FC<props> = ({ control, name, loadingLog=false}) => {

    const classes = useStyles();
    const { t } = useTranslation("Mvm");
    const { t: _t } = useTranslation("General");
    const { fields: _fields } = useFieldArray({ control, name: name });
    const fields = _fields as Record<string, any>[];

    const dialogRef = useRef<{ open: (log: any) => void }>(null);

    const handleRowClick = useCallback((rowData: any, rowMeta: { dataIndex: number }) => {
        dialogRef.current?.open(fields[rowMeta.dataIndex]);
    }, [fields]);
    
    const myTheme = createTheme({
        overrides: {
            MuiTableBody: {
                root: {
                    cursor: 'pointer'
                }
            }
        }
    })

    const columns = [
        {
            name: 'logDate',
            label: String(t('logDate')),
            options: {
                sort: true,
                setCellProps: () => ({
                    align: "left"
                }),
                customBodyRender: (value: any, tableMeta: any, updateValue: any) => {
                    return utilsDate.DateTimeSecond(value);
                }
            }
        },  
        {
            name: 'logTypeDescription',
            label: String(t('logType')),
            options: {
                filterList: Array.from(new Set(fields.map((row, index) => {return row["logTypeDescription"]}).filter((x: any) => x !== 'Recebido Retorno do Click'))),
                sort: false,
                setCellHeaderProps: () => ({
                    align: "center",
                  }),
                setCellProps: () => ({
                    align: "center"
                }),
            }
        },
        {
            name: 'createdBy',
            label: String(t('logUser')),
            options: {
                sort: false,
                setCellHeaderProps: () => ({
                    align: "center",
                  }),
                setCellProps: () => ({
                    align: "center"
                })               
            }
        }
    ] 
  
    return (
        <Grid style={{ marginTop: 20, width: "98%", marginLeft: 10, marginBottom: 10 }}>
            <Typography className={classes.root} style={{ marginLeft: 0, marginBottom: 10 }} >
                {t("mvmlogs")}
            </Typography>            
            {loadingLog ? (
                <Box style={{ display: 'flex', padding: "10px", alignItems: 'center', justifyContent: 'center', 
                }} className='MuiPaper-elevation4-5206'>
                    <CircularProgress color="inherit" />
                </Box>
            ):(
            <MuiThemeProvider theme={myTheme} >
                <MUIDataTable
                    title=""
                    data={fields}
                    columns={columns}
                    options={{
                        ...getDefaultGridOptions(_t),
                        serverSide: false,
                        pagination: false,
                        sortOrder: {
                            name: 'logDate',
                            direction: 'desc'
                        },
                        selectToolbarPlacement: "none",
                        filter: true,
                        filterType: 'multiselect',
                        setFilterChipProps: (colIndex, colName, data) => {
                            return {
                              color: 'primary',
                              variant: 'outlined',
                            };
                          },
                          textLabels: { 
                              filter: {
                                title: _t("filters"),
                                reset: _t("clean"),
                              }
                        },
                        search: false,
                        download: false,
                        print: false,
                        viewColumns: false,
                        selectableRows: 'none',
                        onRowClick: handleRowClick,
                    }}
                />
            </MuiThemeProvider>
            )}

            <LogDetailDialog ref={dialogRef} />
        </Grid>
    )
}

export default MvmLogList

